import { StyleSheet, ViewStyle } from 'react-native'

import { ThemeProps } from '@common/styles/themeConfig'

interface Style {
  warningsModal: ViewStyle
}

const getStyles = (theme: ThemeProps) =>
  StyleSheet.create<Style>({
    warningsModal: {
      backgroundColor: theme.primaryBackground,
      paddingHorizontal: 0,
      paddingVertical: 0,
      overflow: 'hidden',
      // Match the design-system `Dialog` width so the confirm popup doesn't
      // stretch across the whole viewport on wide (tab / mobile-web) layouts.
      width: 480,
      maxWidth: '90%'
    }
  })

export default getStyles
